<template>
  <input
    ref="base-input"
    :value="maskedValue"
    class="base-input"
    :class="{
      'base-input--invalid': invalid,
    }"
    :maxlength="getMaxLength()"
    :size="getSize()"
    @input="handleInputChange"
  />
</template>

<script>
  export default {
    name: 'BaseInput',
    emits: ['update:modelValue'],
    props: {
      modelValue: {
        type: [String, Number],
        required: false,
        default: '',
      },
      mask: {
        type: String,
        required: false,
        default: '',
        validator: (value) => ['', 'phone'].includes(value),
      },
      invalid: Boolean,
    },
    data: () => ({
      maskOptions: {
        phone: {
          mask: '###-###-####',
          lazy: false,
        },
      },
    }),
    computed: {
      maskedValue() {
        if (this.mask === 'phone') {
          return this.formatPhoneNumber(this.modelValue);
        }
        return this.modelValue;
      },
    },
    methods: {
      handleInputChange(event) {
        const newValue = event.target.value;

        if (this.mask === 'phone') {
          const unformattedValue = this.unformatPhoneNumber(newValue);
          this.$emit('update:modelValue', unformattedValue);
          this.$refs['base-input'].value =
            this.formatPhoneNumber(unformattedValue);
          return;
        }
        this.$emit('update:modelValue', newValue);
      },
      getMaxLength() {
        if (this.mask === 'phone') {
          return 14;
        }
        return null;
      },
      getSize() {
        if (this.mask === 'phone') {
          return 14;
        }
        return null;
      },
      formatPhoneNumber(value) {
        const digits = value.replace(/\D/g, '');
        const matched = digits.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);

        if (matched) {
          // Format as (###) ###-####
          const formattedNumber = `(${matched[1]})${matched[2] ? ` ${matched[2]}` : ''}${matched[3] ? `-${matched[3]}` : ''}`;
          return formattedNumber;
        }
        return digits;
      },
      unformatPhoneNumber(value) {
        return value.replace(/\D/g, '');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .base-input {
    background: #fff;
    border: 1px solid #a7a9ab;
    border-radius: 4px;
    color: #a7a9ab;
    font-size: 16px;
    font-family: 'Open Sans', sans-serif;
    line-height: 24px;
    padding: 12px 20px;
    transition:
      color 0.33s,
      border-color 0.33s;
    min-height: 50px;

    &--invalid {
      border-color: var(--itr-color-danger) !important;
    }
  }
</style>
